import { motion } from "framer-motion";

const quotes = [
  {
    q: "Their market analysis reshaped how we approach mid-life narrowbody trading. Rigor you rarely see outside institutional lessors.",
    who: "Head of Trading",
    role: "European Aircraft Lessor",
  },
  {
    q: "JS Aviation ran technical due diligence on a fleet of Diamond DA42s for our academy. Precise, discreet, on schedule.",
    who: "Accountable Manager",
    role: "ATO — Southeast Asia",
  },
  {
    q: "They advised — they didn't sell. That is why we've closed three transactions with them across two continents.",
    who: "Family Office Principal",
    role: "GCC",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="py-32 md:py-40 border-t border-[#0E1B2E]/10 bg-[#F2F2EF]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 text-[#A5854C] mb-16">
          <div className="hairline w-12"></div>
          <span className="font-mono text-[11px] uppercase tracking-[0.35em]">Client voices</span>
        </div>

        <div className="grid grid-cols-12 gap-6">
          {quotes.map((t, i) => (
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.9, delay: i * 0.1 }}
              className="col-span-12 md:col-span-4 border border-[#0E1B2E]/10 bg-white p-8 md:p-10 relative"
              data-testid={`testimonial-${i}`}
            >
              <span className="font-serif text-[80px] leading-[0.5] text-[#C8A97E] absolute -top-2 left-6">“</span>
              <p className="mt-8 font-serif text-[20px] md:text-[22px] leading-[1.4] text-[#0E1B2E] tracking-tight">
                {t.q}
              </p>
              <div className="mt-10 pt-6 border-t border-[#0E1B2E]/10">
                <div className="text-[#0E1B2E] text-[14px]">{t.who}</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#9AA3AE] mt-1">{t.role}</div>
              </div>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
}
